import {
  NOTIFY_SUCCESS,
  NOTIFY_WARNING,
  SET_DRAWER_OPENED,
} from '../../actionConstants';

export const notifyUser = (dispatch, message, isSuccess = true) =>
  dispatch({
    type: isSuccess ? NOTIFY_SUCCESS : NOTIFY_WARNING,
    message,
  });

export const setDrawerOpen = (dispatch, isDrawerOpen) =>
  dispatch({ type: SET_DRAWER_OPENED, isDrawerOpen });
